import React, { useState, useEffect } from 'react';
import './ContactForm.css';
import { postJson } from './api';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';
import LoadingSpinner from './components/LoadingSpinner';

function ContactForm() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'お問い合わせ', path: '/contact' }
  ];

  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formError, setFormError] = useState('');

  useEffect(() => {
    return () => {
      setIsSubmitting(false);
    };
  }, []);

  const validateForm = () => {
    if (
      !formData.name ||
      !formData.company ||
      !formData.phone ||
      !formData.email ||
      !formData.message
    ) {
      return '全ての項目の入力は必須です。';
    }
    if (!/^\d+$/.test(formData.phone)) {
      return '電話番号は数値のみで入力してください。';
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      return 'メールアドレスの形式が正しくありません。';
    }
    return '';
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const error = validateForm();
    if (error) {
      setFormError(error);
      setIsSubmitting(false);
      return;
    }

    try {
      await postJson('/api/contact', formData);

      setShowModal(true);
      setFormError('');
      setFormData({
        name: '',
        company: '',
        phone: '',
        email: '',
        message: '',
      });
    } catch (error) {
      console.error('エラー発生:', error);
      setFormError('送信中にエラーが発生しました。');
    } finally {
      setIsSubmitting(false);
    }
  };

  const closePopup = () => {
    setShowModal(false);
  };

  return (
    <div className="contact">
      <SEO page="contact" />
      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">CONTACT</p>
          <h1 className="ds-h1">お問い合わせ</h1>
          <p className="ds-lead">
            弊社へのお問い合わせありがとうございます。
            <br />
            内容を確認次第ご連絡させていただきますので今しばらくお待ちください。
          </p>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="contact-panel ds-card">
            {formError && <p className="contact-error" role="alert">{formError}</p>}
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="contact-row">
                <div className="contact-field">
                  <label htmlFor="name">お名前 <span className="contact-required">*</span></label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="山田太郎"
                    required
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="company">会社名 <span className="contact-required">*</span></label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="株式会社サンプル"
                    required
                  />
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-field">
                  <label htmlFor="phone">電話番号 <span className="contact-required">*</span></label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="03-1234-5678"
                    required
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="email">メールアドレス <span className="contact-required">*</span></label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@company.com"
                    required
                  />
                </div>
              </div>

              <div className="contact-field">
                <label htmlFor="message">お問い合わせ内容 <span className="contact-required">*</span></label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="お問い合わせ内容をご記入ください"
                  rows="6"
                  required
                ></textarea>
              </div>

              <div className="contact-submit">
                <button type="submit" disabled={isSubmitting} className="ds-btn ds-btn--primary ds-btn--arrow">
                  {isSubmitting ? '送信中...' : '送信する'}
                </button>
                {isSubmitting && (
                  <div style={{ marginTop: '1rem' }}>
                    <LoadingSpinner />
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </section>

      {showModal && (
        <div className="contact-modal">
          <div className="contact-modal-box">
            <p>
              お問い合わせありがとうございます。<br></br>
              担当者からのご連絡をお待ちください。
            </p>
            <button onClick={closePopup} className="ds-btn ds-btn--primary">閉じる</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactForm;
